import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  loaderSlow: {
    animationDuration: '10s',
  },
  title: {
    margin: theme.spacing(1.5, 0),
  },
  inBackdrop: {
    padding: theme.spacing(2),
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: theme.spacing(0.5),
  },
});
